var exports = {
  "z": "x8b4e8595--912e04--error",
  "i": "x8b4e8595--912e04--error-button",
};

module.exports = exports;
